<template>
  <v-app>
    <component :is="$route.meta.layout || 'div'">
      <div>
        <router-view />
      </div>
    </component>
    <notifications />
    <!-- Cookie banner deactivated — WordPress handles cookies for public pages,
         Vue app uses zero functional cookies (auth=sessionStorage, locale=localStorage) -->
    <!-- <cookie-consent-dialog
      ref="cookieConsentDialog"
    /> -->
  </v-app>
</template>

<script>
  // import CookieConsentDialog from '@/components/CookieConsentDialog.vue'
  import NotificationService from '@/services/NotificationService'
  import LanguageService from '@/services/LanguageService'
  import { syncVuetifyLocale } from '@/plugins/vuetify'

  export default {
    name: 'App',
    components: {
      // CookieConsentDialog,
    },
    watch: {
      // Vuetify 3 keeps its own locale (see plugins/vuetify.js); keep it in step with the
      // app locale so built-in component strings follow the language switcher.
      '$i18n.locale': {
        immediate: true,
        handler (locale) {
          syncVuetifyLocale(locale)
        },
      },
    },
    data () {
      return {
        userWantsCookies: 'false',
        customer: {},
      }
    },
    mounted () {
      // Setup idle timeout
      let lastActivity = Date.now()
      const idleTimeoutMs = process.env.VUE_APP_IDLE_TIME * 1000
      
      // Reset timer on any user activity
      const resetTimer = () => {
        lastActivity = Date.now()
      }
      
      // Listen for user activity
      this.idleEvents = ['mousedown', 'keydown', 'touchstart', 'scroll']
      this.idleResetTimer = resetTimer
      this.idleEvents.forEach(event => {
        document.addEventListener(event, resetTimer)
      })

      // Check for timeout every 5 seconds
      this.idleIntervalId = setInterval(() => {
        if (sessionStorage.token && Date.now() - lastActivity > idleTimeoutMs) {
          console.log('[AUTH] Idle timeout - logging out')
          this.doLogout()
          this.$router.push('/login').catch(() => {})
        }
      }, 5000)

      // Cookie banner deactivated — WordPress handles cookies for public pages,
      // Vue app uses zero functional cookies (auth=sessionStorage, locale=localStorage).
      // GA script was also broken (ERB syntax instead of process.env). Fix deferred.
      //
      // this.userWantsCookies = this.$cookies.isKey('wantsCookies') ? this.$cookies.get('wantsCookies') : false
      // if (!(this.userWantsCookies === 'true')) {
      //   this.$refs.cookieConsentDialog.open()
      // }
      //
      // this.userWantsEssentialCookies = this.$cookies.isKey('wantsEssentialCookies') ? this.$cookies.get('wantsEssentialCookies') : false
      // if (this.userWantsEssentialCookies === 'true') {
      //   // placeholder
      // }
      //
      // this.userWantsAnalysisCookies = this.$cookies.isKey('wantsAnalysisCookies') ? this.$cookies.get('wantsAnalysisCookies') : false
      // if (this.userWantsAnalysisCookies === 'true') {
      //   const analyticsScript = document.createElement('script')
      //   analyticsScript.setAttribute('async', true)
      //   analyticsScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=<%= VUE_APP_GOOGLE_ANLYTICS_ID %>')
      //   document.head.appendChild(analyticsScript)
      // }
    },
    created () {
        window.addEventListener('beforeinstallprompt', (event) => {
          event.preventDefault()
          this.$store.commit('settingsModule/setInstallEvent', event)
        })
        LanguageService.getAllLanguages()
        .then((response) => {
          const untranslatedLanguages = response.data
          this.$store.commit('languageModule/setTranslatedLanguages', untranslatedLanguages)
        })
        .catch((error) => NotificationService.error(error.message))
    },
    beforeUnmount () {
      // The idle timer used to leak: mounted() started an interval and added four document
      // listeners with no teardown.
      clearInterval(this.idleIntervalId)
      ;(this.idleEvents || []).forEach(event => {
        document.removeEventListener(event, this.idleResetTimer)
      })
    },
    methods: {
      doLogout () {
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('isCustomer')
        sessionStorage.removeItem('isAdmin')
        sessionStorage.removeItem('name')
        sessionStorage.removeItem('isConfidant')
        sessionStorage.removeItem('required2FA')
      },
    },
  }
</script>

<style>
  @font-face {
    font-family: "Montserrat";
    src: local("Montserrat"),
    url("./assets/fonts/Montserrat.woff2") format("woff2");
  }

  .cursor-pointer {
    cursor: pointer
  }

  ul li{
    margin: 1rem 0;
    margin-left: -10px;
  }

  .v-main {
    max-width: 100% !important;
  }

  .v-application__wrap {
    overflow-x: clip !important;
    min-height: 95vh !important;
  }

  @media (min-width: 960px) {
    .container {
      max-width: 1100px !important;
    }
  }

  @media (max-width: 960px) {
    ul li{
      margin: 1rem 0;
      margin-left: -23px;
    }
  }

</style>
